import { api } from 'API';
import { blankAlternativeMedicineInvoice } from 'Context/AlternativeMedicine';
import { blankInvoice } from 'Context/CannabisContext';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/NewRequest/RefundTypes';
const analyzeInvoiceUrl = '/invoice/analyze-invoice';
const refundEntitledBaseUrl = '/LongTermEquipment';
const refundEntitledAlternativeMedicineUrl =
  '/AlternativeMedicine/IsUserEntitled';
const treatmentTypeUrl = '/AlternativeMedicine/TreatmentTypes';

export interface IReimbursements {
  id: number;
  name: string;
  priority: number;
  iconUrlPath: string;
  internalLink: string;
  externalLink: string;
  reqTypeId: string;
  reqSubTypeId: string;
}

export interface IAnalyzeInvoice {
  invoiceDate: Date;
  invoiceId: string;
  invoiceTotal: number;
}

export interface ITreatmentType {
  id: number;
  value: string;
  comment?: string;
}

export const getReimbursements = async () => {
  const res = await api.get<IReimbursements[]>(addImposterToUrl(baseUrl, true));
  if (res?.data) return res.data;
  else if (res?.status === HTTP_STATUS_CODES.Forbidden) return [];
};

export const isCannabisRefundEntitled = async () => {
  const res = await api.get<boolean>(
    addImposterToUrl(`${refundEntitledBaseUrl}/IsCannabisRefundEntitled`, true)
  );
  if (res) return res.data;
};

export const isAlternativeMedicineRefundEntitled = async () => {
  const res = await api.get<boolean>(
    addImposterToUrl(refundEntitledAlternativeMedicineUrl, true)
  );
  if (res) return res.data;
};

export const analyzeInvoice = async (body: any) => {
  const res = await api.post<IAnalyzeInvoice>(
    addImposterToUrl(analyzeInvoiceUrl, true),
    body,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  if (res) return { ...blankAlternativeMedicineInvoice, ...res.data };
  else return blankAlternativeMedicineInvoice;
};

export const getTreatmentTypes = async () => {
  const res = await api.get(addImposterToUrl(treatmentTypeUrl, true));
  if (res) return res.data;
};
